import "./Loading.css"

export default function Loading() {
  return (
    <div className="loader-container">
      <h2 className="loader">working...</h2>
    </div>
  )
}
